<div
  class="notification-wrapper"
  [class.show]="showNotifications"
  [class]="currentNotification.type"
>
  <p
    class="title"
    *ngIf="currentNotification.title"
  >
    {{ currentNotification.title }}
  </p>

  <ul *ngIf="showNotifications">
    <li *ngFor="let message of currentNotification.messages">
      {{ message }}
    </li>
  </ul>
</div>
